export const SCOPE = ['https://www.googleapis.com/auth/drive.readonly']
